var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-slider'),_c('services-section'),_c('testimonials'),_c('middle-section'),_c('blog-with-slider'),_c('subscribe-form'),_c('partners-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }